import React from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"

import Home6 from "./Pages/Home6"

import About1 from "./Pages/About1"

import ScrollToTop from "./Common/ScrollToTop"

import Contact1 from "./Pages/Contact1"
import MoreProduct from "./Pages/MoreProduct"

class Components extends React.Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <ScrollToTop />
        <div className="page-wraper">
          <Routes>
            {/* <Route path="/" element={<Home1 />} /> */}
            <Route path="/" element={<Home6 />} />
            <Route path="/about-1" element={<About1 />} />
            <Route path="/contact-us" element={<Contact1 />} />
            <Route path="/products" element={<MoreProduct />} />
            {/* <Route element={<Error />} /> */}
          </Routes>
        </div>
      </BrowserRouter>
    )
  }
}

export default Components
